import TikToklogo from "../../assets/socialglass/TikTok-logo.svg";
import instagram_logo from "../../assets/socialglass/instagram_icon.svg";
import x from "../../assets/socialglass/x.svg";
import youtubeLogo from "../../assets/socialglass/youtube-logo.svg";
import { Platform } from "../types/socialGlass";

export const PLATFORM_LOGOS: Record<Platform, string> = {
  tiktok: TikToklogo,
  instagram: instagram_logo,
  twitter: x,
  x: x,
  youtube: youtubeLogo,
};

export const PLATFORM_LOGO_CLASSES: Record<Platform, string> = {
  tiktok: "ml-0 h-8 w-8",
  instagram: "ml-0 h-6 w-6",
  twitter: "ml-auto h-8 w-8",
  x: "ml-auto h-8 w-8",
  youtube: "ml-0 h-10 w-8",
};

export const PLATFORM_PATTERN = /(?:https?:\/\/)?(?:www\.)?(tiktok|youtube|youtu|instagram|x|twitter)\./;
